// extracted by mini-css-extract-plugin
export default {"footer":"F_bV","row":"F_cP","menuColumn":"F_cQ","trademarks":"F_cR"};